module.exports = __webpack_public_path__ + "img/cancelar.1cdedfa3.svg";